import { render, staticRenderFns } from "./FilterData.vue?vue&type=template&id=2ed60bc1&"
import script from "./FilterData.vue?vue&type=script&lang=js&"
export * from "./FilterData.vue?vue&type=script&lang=js&"
import style0 from "./FilterData.vue?vue&type=style&index=0&id=2ed60bc1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports